import React from "react";
import getRequiredMessage from "./getRequiredMessage";
import { FormattedMessage } from "react-intl";

export const defaultRequiredMessage = (
  <FormattedMessage
    id="components.atoms.Form.Input.requiredError"
    defaultMessage="This is a required field"
  />
);

export default (
  props,
  requiredMessage = defaultRequiredMessage,
  shouldAddRequiredMessage = true
) => {
  const shouldFillInputMessage =
    shouldAddRequiredMessage &&
    (typeof props.isPristine !== "function" || !props.isPristine()) &&
    props.showRequired() &&
    getRequiredMessage(requiredMessage, props);

  return [
    ...(shouldFillInputMessage ? [shouldFillInputMessage] : []),
    ...props.getErrorMessages(),
  ].filter((error) => typeof error !== "string" || error.length > 0);
};
